import { z } from 'zod';

import { BaseStepDefinition } from './BaseStepDefinition';

/**
 * Kind of a placeholder for now since I've moved some of the do-while concepts into BaseStepDefinition, think about what to call this.
 */
export const GenericStepDefinition = BaseStepDefinition.extend({
  type: z.literal('generic'),
});
export type GenericStepDefinition = z.infer<typeof GenericStepDefinition>;
